import React, { Component } from 'react'
import { Row, Col } from 'react-bootstrap'
import { Field } from 'redux-form'
import { renderTextField } from '../../Forms/fieldRenderers'
import { TextField } from '@material-ui/core'
import Grid from '@material-ui/core/Grid'
import moment from 'moment'

class CamposCaratulaCierreDeCarga extends Component {
  render () {
    const {
      fechaZarpada,
      changeZarpada
    } = this.props

    return (
      <div>
        <Row>
          <Grid container justify='space-around'>
            <Col md={4}>
              <TextField
                id='datetime-local'
                label='Zarpada'
                name='fechaZarpada'
                type='datetime-local'
                defaultValue={moment(fechaZarpada).format('YYYY-MM-DD[T]HH:mm') || moment().format('YYYY-MM-DD[T]HH:mm')}
                onChange={(e) => { changeZarpada(e) }}
                helperText='Fecha/Hora prevista de zarpada'
                InputLabelProps={{
                  shrink: true
                }}
              />
            </Col>
            <Col md={2} >
              <Field
                name='peso'
                type='text'
                label='Peso Total'
                component={renderTextField}
                autoFocus={false}
                disabled
              />
            </Col>
            <Col md={6} />
          </Grid>
        </Row>
      </div>
    )
  }
}

export default CamposCaratulaCierreDeCarga
